<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col justify="center" lg="6">
        <h2>The African Pollen Database</h2>
        <p></p>
        <v-img contain height="100px" src="../../assets/bestiole.gif"></v-img>
        <p></p>
        <p>
          The African Pollen Database (APD) is an international network, which
          supports the development of scientific research in Africa in the field
          of past environmental and climate change.
        </p>
        <p>
          Principle and basis for the functioning of the African Pollen Database
          have been adopted during a meeting organized with this purpose at
          Bierville (France) in 1996 and grouping scientists involved in African
          and Malagasy palynology.
        </p>
        <p>
          The long-term objective of the APD is to collect pollen data, place
          them at the disposal of the whole scientific community, to archive the
          information for future generations of researchers and to promote
          international scientific cooperation. It has been initiated in the
          frame of research projects as part of the BIOME 6000 and the PMIP
          projects.
        </p>
        <p>
          Then, the EU (INCO-DC, ENRICH), UNESCO-IGCP, the French CNRS and
          finally the ANR (Belmont Forum program) successively funded the
          network, allowing for the organization of scientific meetings,
          workshops and training courses held at Johannesburg (1997), Marseilles
          (1998, 2001, 2007), Toulouse (1998,1999), Kew (1998), Durban (1999),
          Nanjing (2000), Nairobi (2001), Casablanca (2002), Granada (2004),
          Bloemfontein (2005), Yaoundé (2013), Bondy (2019) and Amsterdam
          (2020).
        </p>
        <p>
          Strong relationships exist between the African Pollen Database and the
          other regional pollen databases, mainly the European one (EPD), which
          stores data from Mediterranean Africa.
        </p>
        <p>
          The APD was initially developed and maintained by Medias-France in
          Toulouse. After a long interruption due to the closure of this data
          center, it is now developed and hosted at IPSL (Institut Pierre Simon
          Laplace). Data will also be available from Neotoma and the IPSL Paleo
          database.
        </p></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
export default {};
</script>

<style>
a:link {
  color: #2b2118;
}
a:visited {
  color: #2b2118;
}
</style>